import React from 'react';
import { motion } from 'framer-motion';

const ServiceCard = ({ title, description, icon, tags, size = 'medium', delay = 0 }) => {
  const sizeClasses = {
    small: 'md:col-span-1 md:row-span-1',
    medium: 'md:col-span-1 md:row-span-1',
    large: 'md:col-span-2 md:row-span-1',
    tall: 'md:col-span-1 md:row-span-2',
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay }}
      whileHover={{ y: -5, transition: { duration: 0.2 } }}
      className={`group bg-white rounded-3xl p-8 border border-gray-100 hover:border-gray-200 shadow-sm hover:shadow-lg transition-all cursor-pointer ${sizeClasses[size]}`}
    >
      {/* Icon */}
      {icon && (
        <div className="mb-6">
          <div className="w-14 h-14 bg-gradient-to-br from-dark-navy to-muted-blue-grey rounded-2xl flex items-center justify-center text-white text-2xl group-hover:scale-110 transition-transform">
            {icon}
          </div>
        </div>
      )}

      {/* Title */}
      <h3 className="text-2xl font-bold text-dark-slate mb-3 tracking-tight group-hover:text-dark-navy transition-colors">
        {title}
      </h3>

      {/* Description */}
      <p className="text-muted-grey leading-relaxed mb-6">
        {description}
      </p>

      {/* Tags */}
      {tags && tags.length > 0 && (
        <div className="flex flex-wrap gap-2">
          {tags.map((tag, index) => (
            <span
              key={index}
              className="px-3 py-1 bg-gray-50 text-muted-grey text-sm rounded-full font-medium"
            >
              {tag}
            </span>
          ))}
        </div>
      )}

      {/* Hover Arrow */}
      <div className="mt-6 opacity-0 group-hover:opacity-100 transition-opacity">
        <span className="text-dark-navy font-medium inline-flex items-center">
          Learn more
          <svg
            className="w-4 h-4 ml-2 transform group-hover:translate-x-1 transition-transform"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 5l7 7-7 7"
            />
          </svg>
        </span>
      </div>
    </motion.div>
  );
};

export default ServiceCard;
